export class CBMError {
  constructor(public code: string, public description: string, public detailsForUser: string = '') {}
}



// WEBPACK FOOTER //
// ./src/app/models/CBMError.model.ts